import { Component, Input } from '@angular/core';
import { DialogCloseReason, DialogBase } from '../base-dialog';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export interface IInputData {
  header: string;
  body?: string;
  fieldName: string;
  fieldType?: 'text' | 'color' | 'date' | 'datetime-local' | 'email' | 'month' | 'number' | 'range' | 'search' | 'tel' | 'time' | 'url' | 'week';
  fieldDefaultValue?: any;
  fieldPlaceHolder?: any;
  fieldValidationCallback?: (fieldValue: any, fieldValidationContext: any) => string;
  fieldValidationContext?: any;
  validationErrorLabelTimeout?: number; //InputDialogComponent.DO_NOT_HIDE_ERROR => do not set timeout
  okCaption?: string;
  cancelCaption?: string;
}

@Component({
  selector: 'input-dialog',
  templateUrl: 'input.html',
  animations: [
    trigger('errorAnimation', [
      state('inactive', style({opacity: 0})),
      state('active', style({opacity: 1})),
      transition('inactive <=> active', animate('500ms'))
    ])
  ],
})
export class InputDialogComponent extends DialogBase {
  static DO_NOT_HIDE_ERROR: number = -1;
  fieldType: string;
  okCaption: string;
  cancelCaption: string;
  lastValidationError: string | Observable<string>;
  fieldPlaceHolder: string;
  validationErrorLabelTimeout: number;
  errorState: string;

  private lastValidationErrorText: string = '';

  get LastValidationErrorText() {
    return this.lastValidationErrorText;
  }

  @Input() fieldValue: string;

  constructor(public translate: TranslateService) {
    super();
  }

  initDialog() {
    this.fieldType = this.extraData.fieldType ? this.extraData.fieldType : 'text';
    this.okCaption = this.extraData.okCaption ? this.extraData.okCaption : this.translate.instant('COMMON.DIALOGS.INFRA.OK');
    this.cancelCaption = this.extraData.cancelCaption ? this.extraData.cancelCaption : this.translate.instant('COMMON.DIALOGS.INFRA.CANCEL');
    this.validationErrorLabelTimeout = this.extraData.validationErrorLabelTimeout ? this.extraData.validationErrorLabelTimeout : 10000;
    this.fieldPlaceHolder = this.extraData.fieldPlaceHolder ? this.extraData.fieldPlaceHolder : '--';

    this.lastValidationErrorText = 'error placeholder';
    this.errorState = 'inactive';

    if (this.extraData.fieldDefaultValue) {
      this.fieldValue = this.extraData.fieldDefaultValue;
    }
  }

  getTypeClass(): string {
    return 'input';
  }

  onKeyDown() {
    this.errorState = 'inactive';
  }

  showValidationError() {
    this.errorState = 'active';

    if (this.validationErrorLabelTimeout !== InputDialogComponent.DO_NOT_HIDE_ERROR) {
      setTimeout(() => {
        this.errorState = 'inactive';
      }, this.validationErrorLabelTimeout);
    }
  }

  submitForm(value: any) {
    this.ok();
  }

  ok() {
    if (this.extraData.fieldValidationCallback) {
      this.lastValidationError = this.extraData.fieldValidationCallback.call(
        null,
        this.fieldValue,
        this.extraData.fieldValidationContext
      );

      if (this.lastValidationError  instanceof Observable) {
        this.lastValidationError.subscribe((result: string) => {
          if (result) {
            this.lastValidationErrorText = result;
            this.showValidationError();
          } else {
            this.close({reason: DialogCloseReason.OK, data: {fieldValue: this.fieldValue}});
          }
        });
      } else {
        if (this.lastValidationError) {
          this.lastValidationErrorText = this.lastValidationError;
          this.showValidationError();
        } else {
          this.close({reason: DialogCloseReason.OK, data: {fieldValue: this.fieldValue}});
        }
      }
    } else {
      this.close({reason: DialogCloseReason.OK, data: {fieldValue: this.fieldValue}});
    }
  }

  cancel() {
    this.close({reason: DialogCloseReason.CANCEL});
  }

}

